import PropTypes from 'prop-types';

const attributesChartLayerType = PropTypes.exact({
  dataKey: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number.isRequired,
  opacity: PropTypes.number.isRequired,
});

const attributesConfigType = PropTypes.exact({
  attributesChartSortOrder: PropTypes.arrayOf(PropTypes.string).isRequired,
  attributesChartLayers: PropTypes.arrayOf(attributesChartLayerType).isRequired,
});

export default attributesConfigType;
